import { enumTipoDocumento, enumTipoOperacion, eTipoGrupo, eTipoLineaMovimientos, eTipoModalidadFacturas } from "src/GlobalConf";
import { ArticuloDTO, ArticuloNumeroSerieDTO, TarifaDescuentosDTO, TarifaPreciosDTO, TipoTarifaDTO } from "./ArticuloDTO";
import { BaseDTO } from "./BaseDTO"
import { CuentaContableDTO } from "./CuentaContableDTO"
import { EntidadCodigoIntDTO } from "./EntidadCodigoIntDTO";
import { EntidadCodigoStringDTO } from './EntidadCodigoStringDTO';
import { EntidadIdGUIDReferenciaExternaDTO } from "./EntidadIdGUIDReferenciaExternaDTO";
import { EntidadSinCodigoDTO } from "./EntidadSinCodigoDTO";
import { FaceGestionDTO } from "./FaceGestionDTO";
import { AlmacenDTO, ClienteDTO, DomicilioGestionDTO, ProveedorDTO } from "./Terceros";
import { TipoIrpfGestionDTO } from "./TipoIrpfGestionDTO";
import { TipoIvaGestionDTO } from "./TipoIvaGestionDTO"
import { SucursalDTO } from "./SucursalDTO";
import { ficherosGetDTO } from "./FicherosGetDTO";

export class DocumentoDTO extends BaseDTO {
    movimientos?: MovimientoDTO[];
    basesIVA?: BaseDocumentoDTO[];
    agentes?: AgenteGestionCabeceraDTO[];
    retencionesFiscales?: RetencionFiscalDTO[];
    albaranes?: DocumentoGestionDTO[];
    tipo?: number;
    tipoDocumento?: number;
    modalidad?: number;
    fecha?: Date | string;
    hora?: Date | string;
    parteCaja?: EntidadIdGUIDReferenciaExternaDTO;
    cliente?: EntidadCodigoStringDTO;
    proveedor?: EntidadCodigoStringDTO;
    asientoContable?: EntidadIdGUIDReferenciaExternaDTO;
    conceptoContable?: EntidadCodigoIntDTO;
    formaPago?: EntidadCodigoIntDTO;
    sucursal?: EntidadCodigoStringDTO;
    clienteServicio?: EntidadCodigoStringDTO;
    proveedorServicio?: EntidadCodigoStringDTO;
    domicilioEnvio?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    almacenDestino?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    facturacion?: EntidadIdGUIDReferenciaExternaDTO;
    factura?: DocumentoGestionDTO;
    documentoOrigen?: EntidadIdGUIDReferenciaExternaDTO;
    facturaRectificada?: DocumentoGestionDTO;
    ruta?: EntidadCodigoStringDTO;
    proyecto?: EntidadSinCodigoDTO;
    obra?: EntidadCodigoStringDTO;
    empresaCRM?: EntidadCodigoStringDTO;
    tipoFicheroInventario?: EntidadCodigoStringDTO;
    datosDomicilioPrincipal?: DomicilioGestionDTO;
    datosDomicilioEnvio?: DomicilioGestionDTO;
    faceOficinaContable?: FaceGestionDTO;
    faceOrganoGestor?: FaceGestionDTO;
    faceUnidadTramitadora?: FaceGestionDTO;
    faceOrganoProponente?: FaceGestionDTO;
    serie?: SerieDocumentoGestionDTO;
    registro?: number;
    registroContable?: number;
    nombre?: string
    nif?: string
    nifRepresentante?: string
    paisIdentificacion?: string
    tipoIdentificacion?: number;
    numeroIdentificacion?: string
    varios?: number;
    numeroDocumento?: string
    fechaDocumento?: Date | string;
    justificanteContable?: string
    ampliacionContable?: string
    actividad?: number;
    iva?: number;
    ivaIncluido?: number;
    contabilizacionNegativa?: boolean;
    regimenFiscal?: number;
    excluirTesoreria?: number;
    autodocumento?: number;
    rectificativa?: number;
    inicioRango?: string
    finRango?: string
    documentosRango?: number;
    textoRectificacion?: string
    fechaValor?: Date | string;
    cuentasContablesAutomaticas?: number;
    referenciaTercero?: string
    referenciaInterna?: string
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    peso?: number;
    bultos?: number;
    volumen?: number;
    estadoContabilidad?: number;
    observaciones?: string
    modoEnvio?: number;
    fechaHoraImpresion?: Date | string;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    importeDescuento4?: number;
    importeCancelado?: number;
    totalBruto?: number;
    totalBases?: number;
    totalIVA?: number;
    totalRecargo?: number;
    totalDocumento?: number;
    totalCargosFinal?: number;
    totalAbonosFinal?: number;
    totalRetenciones?: number;
    totalAPagar?: number;
    fechaPrevista?: Date | string;
    firmado?: number;
    referenciaExterna?: string
    estado?: number;
    estadoTesoreria?: number;
    estadoTesoreriaTexto?: number;
    controlAlmacen?: number;
    checksum?: string
    fechaRegistro?: Date | string;
    textoDescripcionSII?: string
    referenciaOtraParte?: string
    fechaOperacion?: Date | string;
    diferenciasEnCalculo?: number;
    fechaPrevistaEntrega?: Date | string;
    faceReferenciaOperacionReceptor?: string
    faceReferenciaExpediente?: string
    identificacionRespuesta?: string
    //Propiedades creadas para la vista y los calculos:
    totalDescuento?: number;
    totalIvaNoDeducible?: number;
    sumaAnticipoPre?: number;
    historicoEstados?: EstadoEntidadAsignacionDTO[];

}

export class MovimientoDTO extends BaseDTO {
    movimientosArticulosNumerosSerie?: MovimientoANSDTO[]
    agentes?: AgenteGestionLineaDTO[]
    referenciaExterna?: string;
    linea?: number;
    sublinea?: number;
    regimenFiscal?: number;
    tipoMovimiento?: number;
    tipoLinea?: number;
    actividad?: number;
    controlAlmacen?: number;
    gestionBruto?: number;
    id_Motivo?: number;
    id_Albaran?: number;
    //articulo?: EntidadCodigoStringDTO;
    articulo?: ArticuloDTO;
    articuloAlmacen?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    almacenDestino?: EntidadCodigoStringDTO;
    obra?: EntidadCodigoStringDTO;
    tipoIva?: TipoIvaGestionDTO;
    tipoIrpf?: TipoIrpfGestionDTO;
    inversion?: number;
    prorrata?: number;
    tipoOperacion?: number;
    descripcion?: string;
    formula?: number;
    unidad1?: number;
    unidad2?: number;
    unidad3?: number;
    bultos?: number;
    peso?: number;
    volumen?: number;
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    precio?: number;
    precioConIva?: number;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    descuentoCantidad?: number;
    importeDescuentoCantidad?: number;
    descuentoLinea?: number;
    importe?: number;
    importeConIva?: number;
    controlImpresion?: number;
    importeNeto?: number;
    importeNetoConIva?: number;
    medida1?: number;
    medida2?: number;
    medida3?: number;
    medida4?: number;
    medida5?: number;
    medida6?: string;
    medida7?: string;
    precioManual?: boolean;
    porcentajeNoDeducible?: number;
    importeCompra?: number;
    identificacionRespuesta?: string;
    //Propiedades creadas para la vista y los calculos:
    importeBruto?: number;
}

export class MovimientoANSDTO extends BaseDTO {
    articuloNumeroSerie?: ArticuloNumeroSerieDTO;
    linea?: number;
    unidad1?: number;
    unidad2?: number;
    unidad3?: number;
}

export class AgenteGestionCabeceraDTO extends BaseDTO {
    nivel?: number;
    agente?: EntidadCodigoStringDTO
    comisionPorcentaje?: number;
    importeComisionFija?: number;
}

export class AgenteGestionLineaDTO extends AgenteGestionCabeceraDTO {
    comisionCantidad?: number;
}

export class BaseDocumentoDTO extends BaseDTO {
    linea?: number;
    tipoIva?: TipoIvaGestionDTO
    baseImponible?: number;
    baseImponibleCalculada?: number;
    importeIVA?: number;
    importeRecargo?: number;
    actividad?: number;
    regimenFiscal?: number;
    porcentajeNoDeducible?: number;
    inversion?: number;
    prorrata?: number;
    tipoOperacion?: number;
    cuentaIVA?: CuentaContableDTO
    cuentaRecargo?: CuentaContableDTO
    //Propiedades creadas para la vista y los calculos:
    total?: number;
    importeIvaNoDeducible?:number;
    importeRecargoNoDeducible?: number;
    
}

export class RetencionFiscalDTO extends BaseDTO {
    linea?: number;
    baseImponible?: number;
    importe?: number;
    actividad?: number;
    tipoRetencionFiscal?: TipoRetencionFiscalDTO;
    modalidad?: number;
    cuentaImpuesto?: CuentaContableDTO;
}

export class TipoRetencionFiscalDTO extends BaseDTO {
    codigo?: number;
    porcentaje?: number;
    clave?: string;
    subclave?: number;
}

export class DocumentoGestionDTO extends BaseDTO {
    referenciaExterna?: string;
    tipoDocumento?: number;
    tipoDocumentoTexto?: string;
    numeroDocumento?: string;
    fechaDocumento?: Date | string;
    identificacionRespuesta?: string;
}

export class SerieDocumentoGestionDTO extends BaseDTO {
    referenciaExterna?: string;
    serie?: string;
    nombre?: string;
}

export class PedidoDTO extends BaseDTO {
    movimientos?: MovimientoDTO[];
    basesIVA?: BaseDocumentoDTO[];
    agentes?: AgenteGestionCabeceraDTO[];
    retencionesFiscales?: RetencionFiscalDTO[];
    modalidad?: number;
    fecha?: Date | string;
    hora?: Date | string;
    cliente?: EntidadCodigoStringDTO;
    proveedor?: EntidadCodigoStringDTO;
    formaPago?: EntidadCodigoIntDTO;
    sucursal?: EntidadCodigoStringDTO;
    clienteServicio?: EntidadCodigoStringDTO;
    proveedorServicio?: EntidadCodigoStringDTO;
    domicilioEnvio?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    documentoOrigen?: EntidadIdGUIDReferenciaExternaDTO;
    ruta?: EntidadCodigoStringDTO;
    proyecto?: EntidadSinCodigoDTO;
    obra?: EntidadCodigoStringDTO;
    empresaCRM?: EntidadCodigoStringDTO;
    datosDomicilioPrincipal?: DomicilioGestionDTO;
    datosDomicilioEnvio?: DomicilioGestionDTO;
    faceOficinaContable?: FaceGestionDTO;
    faceOrganoGestor?: FaceGestionDTO;
    faceUnidadTramitadora?: FaceGestionDTO;
    faceOrganoProponente?: FaceGestionDTO;
    serie?: SerieDocumentoGestionDTO;
    registro?: number;
    nombre?: string
    nif?: string
    nifRepresentante?: string
    paisIdentificacion?: string
    tipoIdentificacion?: number;
    numeroIdentificacion?: string
    varios?: number;
    numeroDocumento?: string
    fechaDocumento?: Date | string;
    actividad?: number;
    iva?: number;
    ivaIncluido?: number;
    regimenFiscal?: number;
    autodocumento?: number;
    fechaValor?: Date | string;
    referenciaTercero?: string
    referenciaInterna?: string
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    peso?: number;
    bultos?: number;
    volumen?: number;
    observaciones?: string
    fechaHoraImpresion?: Date | string;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    importeDescuento4?: number;
    importeCancelado?: number;
    totalBruto?: number;
    totalBases?: number;
    totalIVA?: number;
    totalRecargo?: number;
    totalDocumento?: number;
    totalCargosFinal?: number;
    totalAbonosFinal?: number;
    totalRetenciones?: number;
    totalAPagar?: number;
    fechaPrevista?: Date | string;
    firmado?: number;
    referenciaExterna?: string
    //estado?: number;
    estadoTesoreria?: number;
    estadoTesoreriaTexto?: number;
    estadoActual?: EstadoEntidadAsignacionDTO;
    controlAlmacen?: number;
    checksum?: string;
    referenciaOtraParte?: string
    diferenciasEnCalculo?: number;
    fechaPrevistaEntrega?: Date | string;
    faceReferenciaOperacionReceptor?: string;
    faceReferenciaExpediente?: string;
    identificacionRespuesta?: string;
    factura?: DocumentoGestionDTO;
    historicoEstados?: EstadoEntidadAsignacionDTO[];

}

export class FacturaDTO extends BaseDTO {
    movimientos?: MovimientoDTO[];
    basesIVA?: BaseDocumentoDTO[];
    agentes?: AgenteGestionCabeceraDTO[];
    retencionesFiscales?: RetencionFiscalDTO[];
    albaranes?: DocumentoGestionDTO[];
    modalidad?: number;
    modalidadTexto?: string;
    fecha?: Date | string;
    hora?: Date | string;
    parteCaja?: EntidadIdGUIDReferenciaExternaDTO;
    cliente?: EntidadCodigoStringDTO;
    proveedor?: EntidadCodigoStringDTO;
    asientoContable?: EntidadIdGUIDReferenciaExternaDTO;
    conceptoContables?: EntidadCodigoIntDTO;
    formaPago?: EntidadCodigoIntDTO;
    sucursal?: EntidadCodigoStringDTO;
    clienteServicio?: EntidadCodigoStringDTO;
    proveedorServicio?: EntidadCodigoStringDTO;
    domicilioEnvio?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    facturacion?: EntidadIdGUIDReferenciaExternaDTO
    documentoOrigen?: EntidadIdGUIDReferenciaExternaDTO;
    facturaRectificada?: DocumentoGestionDTO;
    ruta?: EntidadCodigoStringDTO;
    proyecto?: EntidadSinCodigoDTO;
    obra?: EntidadCodigoStringDTO;
    empresaCRM?: EntidadCodigoStringDTO;
    datosDomicilioPrincipal?: DomicilioGestionDTO;
    datosDomicilioEnvio?: DomicilioGestionDTO;
    faceOficinaContable?: FaceGestionDTO;
    faceOrganoGestor?: FaceGestionDTO;
    faceUnidadTramitadora?: FaceGestionDTO;
    faceOrganoProponente?: FaceGestionDTO;
    serie?: SerieDocumentoGestionDTO;
    registro?: number;
    nombre?: string
    nif?: string
    nifRepresentante?: string
    paisIdentificacion?: string
    tipoIdentificacion?: number;
    numeroIdentificacion?: string
    varios?: number;
    numeroDocumento?: string
    fechaDocumento?: Date | string;
    justificanteContable?: string;
    ampliacionContable ?: string;
    actividad?: number;
    iva?: number;
    ivaIncluido?: number;
    regimenFiscal?: number;
    autodocumento?: number;
    rectificativa ?: number;
    inicioRango ?: string;
    finRango  ?: string;
    documentosRango ?: number;
    textoRectificacion ?: string;
    fechaValor?: Date | string;
    referenciaTercero?: string
    referenciaInterna?: string
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    peso?: number;
    bultos?: number;
    volumen?: number;
    observaciones?: string
    fechaHoraImpresion?: Date | string;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    importeDescuento4?: number;
    importeCancelado?: number;
    totalBruto?: number;
    totalBases?: number;
    totalIVA?: number;
    totalRecargo?: number;
    totalDocumento?: number;
    totalCargosFinal?: number;
    totalAbonosFinal?: number;
    totalRetenciones?: number;
    totalAPagar?: number;
    fechaPrevista?: Date | string;
    firmado?: number;
    referenciaExterna?: string
    estado?: number;
    estadoTesoreria?: number;
    controlAlmacen?: number;
    checksum?: string;
    fechaRegistro ?: Date | string;
    textoDescripcionSII ?: string;
    referenciaOtraParte?: string
    fechaOperacion ?: Date | string;
    diferenciasEnCalculo?: number;
    fechaPrevistaEntrega?: Date | string;
    faceReferenciaOperacionReceptor?: string
    faceReferenciaExpediente?: string
    NoContabilizar ?: boolean;
    identificacionRespuesta?: string;
    factura?: DocumentoGestionDTO;
    estadoTesoreriaTexto?: string;
}

export class AlbaranDTO extends BaseDTO {
    movimientos?: MovimientoDTO[];
    basesIVA?: BaseDocumentoDTO[];
    agentes?: AgenteGestionCabeceraDTO[];
    retencionesFiscales?: RetencionFiscalDTO[];
    modalidad?: number;
    fecha?: Date | string;
    hora?: Date | string;
    cliente?: EntidadCodigoStringDTO;
    proveedor?: EntidadCodigoStringDTO;
    formaPago?: EntidadCodigoIntDTO;
    sucursal?: EntidadCodigoStringDTO;
    clienteServicio?: EntidadCodigoStringDTO;
    proveedorServicio?: EntidadCodigoStringDTO;
    domicilioEnvio?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    almacenDestino?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    facturacion?: EntidadIdGUIDReferenciaExternaDTO
    facturaRectificada?: DocumentoGestionDTO;
    ruta?: EntidadCodigoStringDTO;
    proyecto?: EntidadSinCodigoDTO;
    obra?: EntidadCodigoStringDTO;
    empresaCRM?: EntidadCodigoStringDTO;
    datosDomicilioPrincipal?: DomicilioGestionDTO;
    datosDomicilioEnvio?: DomicilioGestionDTO;
    faceOficinaContable?: FaceGestionDTO;
    faceOrganoGestor?: FaceGestionDTO;
    faceUnidadTramitadora?: FaceGestionDTO;
    faceOrganoProponente?: FaceGestionDTO;
    serie?: SerieDocumentoGestionDTO;
    datosTransporte?: DocumentoTransporteDTO;
    registro?: number;
    nombre?: string
    nif?: string
    nifRepresentante?: string
    paisIdentificacion?: string
    tipoIdentificacion?: number;
    numeroIdentificacion?: string
    varios?: number;
    numeroDocumento?: string
    fechaDocumento?: Date | string;
    actividad?: number;
    iva?: number;
    ivaIncluido?: number;
    regimenFiscal?: number;
    autodocumento?: number;
    rectificativa ?: number;
    textoRectificacion ?: string;
    fechaValor?: Date | string;
    referenciaTercero?: string
    referenciaInterna?: string
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    peso?: number;
    bultos?: number;
    volumen?: number;
    observaciones?: string
    fechaHoraImpresion?: Date | string;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    importeDescuento4?: number;
    importeCancelado?: number;
    totalBruto?: number;
    totalBases?: number;
    totalIVA?: number;
    totalRecargo?: number;
    totalDocumento?: number;
    totalCargosFinal?: number;
    totalAbonosFinal?: number;
    totalRetenciones?: number;
    totalAPagar?: number;
    fechaPrevista?: Date | string;
    firmado?: number;
    referenciaExterna?: string
    estado?: number;
    estadoTesoreria?: number;
    estadoTesoreriaTexto?: number;
    noControlarlExistencias?: boolean;
    checksum?: string;
    referenciaOtraParte?: string
    fechaOperacion ?: Date | string;
    diferenciasEnCalculo?: number;
    fechaPrevistaEntrega?: Date | string;
    faceReferenciaOperacionReceptor?: string
    faceReferenciaExpediente?: string
    identificacionRespuesta?: string
    fechaControlSincronizacion?: Date | string;
    factura?: DocumentoGestionDTO;
    documentoOrigen?: EntidadIdGUIDReferenciaExternaDTO;
}

export class PresupuestoDTO extends BaseDTO {
    modalidad?: number;
    fecha?: Date | string;
    hora?: Date | string;
    registro?: number;
    nombre?: string
    nif?: string
    nifRepresentante?: string
    paisIdentificacion?: string
    tipoIdentificacion?: number;
    numeroIdentificacion?: string
    varios?: number;
    numeroDocumento?: string
    fechaDocumento?: Date | string;
    actividad?: number;
    iva?: number;
    ivaTexto?: string;
    ivaIncluido?: number;
    regimenFiscal?: number;
    autodocumento?: number;
    fechaValor?: Date | string;
    referenciaTercero?: string
    referenciaInterna?: string
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    peso?: number;
    bultos?: number;
    volumen?: number;
    observaciones?: string
    fechaHoraImpresion?: Date | string;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    importeDescuento4?: number;
    importeCancelado?: number;
    totalBruto?: number;
    totalBases?: number;
    totalIVA?: number;
    totalRecargo?: number;
    totalDocumento?: number;
    totalCargosFinal?: number;
    totalAbonosFinal?: number;
    totalRetenciones?: number;
    totalAPagar?: number;
    fechaPrevista?: Date | string;
    firmado?: number;
    referenciaExterna?: string
    estado?: number;
    estadoTesoreria?: number;
    estadoTesoreriaTexto?: number;
    controlAlmacen?: number;
    checksum?: string
    referenciaOtraParte?: string
    diferenciasEnCalculo?: number;
    fechaPrevistaEntrega?: Date | string;
    faceReferenciaOperacionReceptor?: string
    faceReferenciaExpediente?: string
    identificacionRespuesta?: string
    fechaControlSincronizacion?: Date | string;
    movimientos?: MovimientoDTO[];
    basesIVA?: BaseDocumentoDTO[];
    agentes?: AgenteGestionCabeceraDTO[];
    retencionesFiscales?: RetencionFiscalDTO[];
    cliente?: EntidadCodigoStringDTO;
    proveedor?: EntidadCodigoStringDTO;
    formaPago?: EntidadCodigoIntDTO;
    sucursal?: EntidadCodigoStringDTO;
    clienteServicio?: EntidadCodigoStringDTO;
    proveedorServicio?: EntidadCodigoStringDTO;
    domicilioEnvio?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    ruta?: EntidadCodigoStringDTO;
    proyecto?: EntidadSinCodigoDTO;
    obra?: EntidadCodigoStringDTO;
    empresaCRM?: EntidadCodigoStringDTO;
    datosDomicilioPrincipal?: DomicilioGestionDTO;
    datosDomicilioEnvio?: DomicilioGestionDTO;
    faceOficinaContable?: FaceGestionDTO;
    faceOrganoGestor?: FaceGestionDTO;
    faceUnidadTramitadora?: FaceGestionDTO;
    faceOrganoProponente?: FaceGestionDTO;
    serie?: SerieDocumentoGestionDTO;
    documentoOrigen?: EntidadIdGUIDReferenciaExternaDTO;
    factura?: DocumentoGestionDTO;
}

export class facturacionDTO extends BaseDTO {
    referenciaExterna?: string;
    tipoDocumento?: number;
    grupoDocumento?: number;
    modalidad?: number;
    serie?: SerieDocumentoGestionDTO;
    tipoDocumentoDestino?: number;
    fecha?: Date | string;
    fechaFactura?: Date | string;
    nombre?: string;
    filtrofecha?: Date | string;
    filtroTercero?: EntidadCodigoStringDTO;
    filtroFormaPago?: EntidadCodigoIntDTO;
    agrupar?: boolean;
    agruparSerie?: boolean;
    agruparFormaPago?: boolean;
    agruparVendedor?: boolean;
    AlbaranesAProcesar?: DocumentoGestionDTO[];
    identificacionRespuesta?: string;
}

export class SerieDocumentoDTO extends BaseDTO {
    referenciaExterna?: string;
    tipo?: number;
    tipoTexto?: string;
    actividad?: number;
    serie?: string;
    nombre?: string;
    ivaIncluido?: boolean;
    ivaExento?: boolean;
    almacen?: EntidadCodigoStringDTO;
    sucursal?: EntidadCodigoStringDTO;
    cuentaContableVentas?: CuentaContableDTO;
    cuentaContableCompras?: CuentaContableDTO;
    cuentaContableVentasAbono?: CuentaContableDTO;
    cuentaContableComprasAbono?: CuentaContableDTO;
    cuentaContableExistencias?: CuentaContableDTO;
    cuentaContableVariacionExistencias?: CuentaContableDTO;
    registros?: RegistrosSerieDocumentosDTO[]
}

export class RegistrosSerieDocumentosDTO extends BaseDTO {
    referenciaExterna?: string;
    fechaInicial?: Date | string;
    fechaFinal?: Date | string;
    numeroInicial?: number;
    numeroFinal?: number;
    bloqueo?: number;

}

export class DocumentoTransporteDTO {
    autorizado?: EntidadCodigoStringDTO;
    nifAutorizado?: string;
    nombreAutorizado?: string;
    codigoRopoAutorizado?: string;
    transportista
    nifTransportista?: string;
    nombreTransportista?: string;
    conductor?: EntidadCodigoStringDTO;
    nifConductor?: string;
    nombreConductor?: string;
    telefono?: string;
    agenteTransporte?: EntidadCodigoStringDTO;
    nifAgenteTransporte?: string;
    nombreAgenteTransporte?: string;
    domicilioAgenteTransporte?: string;
    poblacionAgenteTransporte?: string;
    provinciaAgenteTransporte?: string;
    paisAgenteTransporte?: string;
    vehiculo?: EntidadIdGUIDReferenciaExternaDTO;
    matricula?: string;
    remolque?: string;
    codigoRopoTercero?: string;
    codigoOperacionADR?: number;
}

export class MovimientoTesoreriaDTO extends BaseDTO {
    referenciaExterna?: string;
    fecha?: string | Date;
    hora?: string | Date;
    fechaValor?: string | Date;
    vencimiento?: string | Date;
    fechaPreviaConciliacion?:string | Date;
    fechaValorPreviaConciliacion?:string | Date;
    fechaConciliacion?:string | Date;
    modalidad?: number;
    modalidadTexto?: string;
    importe?:number;
    importeEntregado?:number;
    importeResto?:number;
    ampliacionContable?:string;
    justificanteContable?:string;
    documento?:string;
    observaciones?:string;
    iban?:string;
    bic?:string;
    retencionGarantia?: boolean;
    anulado?:boolean;
    automatico?:boolean;
    sucursal?:EntidadCodigoStringDTO;
    cliente?:EntidadCodigoStringDTO;
    proveedor?:EntidadCodigoStringDTO;
    parteCaja?:EntidadIdGUIDReferenciaExternaDTO;
    liquidacion?: DocumentoGestionDTO;
    cuentaTesoreria?:EntidadCodigoIntDTO;
    conceptoContable?:EntidadCodigoIntDTO;
    asientoContable?:EntidadIdGUIDReferenciaExternaDTO;
    tipoTarjetaBancaria?:EntidadCodigoStringDTO;
    tarjetaBancaria?:EntidadCodigoStringDTO;
    terminalTesoreria?:EntidadCodigoIntDTO;
    origenAnulacion?:EntidadIdGUIDReferenciaExternaDTO;
    documentosCancelados?: DocumentoTesoreriaDTO[];
    identificacionRespuesta?:string;
    contabilizar?:boolean;
}

export class VencimientoDTO extends BaseDTO {
    fecha?: string | Date;
    hora?: string | Date;
    fechaValor?: string | Date;
    vencimiento?: string | Date;
    importe?:number;
    importeEntregado?:number;
    importeResto?:number;
    ampliacionContable?:string;
    justificanteContable?:string;
    documento?:string;
    observaciones?:string;
    iban?:string;
    bic?:string;
    sucursal?:EntidadCodigoStringDTO;
    cliente?:EntidadCodigoStringDTO;
    proveedor?:EntidadCodigoStringDTO;
    cuentaTesoreria?:EntidadCodigoIntDTO;
    conceptoContable?:EntidadCodigoIntDTO;
    asientoContable?:EntidadIdGUIDReferenciaExternaDTO;
    terminalTesoreria?:EntidadCodigoIntDTO;
    origenAnulacion?:EntidadIdGUIDReferenciaExternaDTO;
    documentosCancelados?: DocumentoTesoreriaDTO[];
    identificacionRespuesta?:string;
    contabilizar?:boolean;
}

export class DocumentoTesoreriaDTO {
    documento?: DocumentoGestionDTO
    importeCancelacion?: number;
    identificacionRespuesta?: string;
}

export class DocumentoApp{
    tipo: enumTipoDocumento
    modalidadFactura?: eTipoModalidadFacturas
    tipoOperacion: eTipoGrupo
    listaArticulos: ArticuloDocumentoApp[] = [];
    serie: SerieDocumentoDTO;
    tercero: ClienteDTO | ProveedorDTO;
    almacen: AlmacenDTO | EntidadCodigoStringDTO;
    sucursal: SucursalDTO;
    tarifaPrecioPredeterminada: TipoTarifaDTO;
    tarifaDescuentoPredeterminada: TipoTarifaDTO;
    fecha: Date;
    documentoALO: FacturaDTO | PedidoDTO | AlbaranDTO | PresupuestoDTO;
}

export class ArticuloDocumentoApp{
    numUnidades: number;
    articulo: ArticuloDTO;
    precioPredeterminado: number;
    precioPredeterminadoIva:number;
    precioEspecial: number;
    precioEspecialIva:number;
    descuentoPredeterminado: number;
    descuentoEspecial: number;
    lote?: ArticuloNumeroSerieDTO;
    listaLotes?: ArticuloNumeroSerieDTO[] = [];
    descripcion?: string;
    tipoLinea: eTipoLineaMovimientos = eTipoLineaMovimientos.NORMAL
}

export class EstadoEntidadDTO {
    id: number;
    guidRegistro?: string;
    referenciaExterna?: string;
    codigo?: number;
    orden?: number;
    nombre?: string;
}

export class EstadoEntidadAsignacionDTO {
    id?: number;
    guidRegistro?: string;
    referenciaExterna?: string;
    fecha?: Date | string;
    estado?: EstadoEntidadDTO;
    comentario?: string;
    documento?: DocumentoGestionDTO;
}

export class FacturaSimplificadaDTO extends BaseDTO {
    movimientos?: MovimientoDTO[];
    basesIVA?: BaseDocumentoDTO[];
    agentes?: AgenteGestionCabeceraDTO[];
    retencionesFiscales?: RetencionFiscalDTO[];
    fecha?: Date | string;
    hora?: Date | string;
    parteCaja?: EntidadIdGUIDReferenciaExternaDTO;
    cliente?: EntidadCodigoStringDTO;
    proveedor?: EntidadCodigoStringDTO;
    formaPago?: EntidadCodigoIntDTO;
    sucursal?: EntidadCodigoStringDTO;
    clienteServicio?: EntidadCodigoStringDTO;
    proveedorServicio?: EntidadCodigoStringDTO;
    domicilioEnvio?: EntidadCodigoStringDTO;
    almacen?: EntidadCodigoStringDTO;
    tipoTarifaPrecios?: EntidadCodigoStringDTO;
    tipoTarifaDescuentos?: EntidadCodigoStringDTO;
    facturacion?: EntidadIdGUIDReferenciaExternaDTO
    facturaRectificada?: DocumentoGestionDTO;
    ruta?: EntidadCodigoStringDTO;
    datosDomicilioPrincipal?: DomicilioGestionDTO;
    datosDomicilioEnvio?: DomicilioGestionDTO;
    serie?: SerieDocumentoGestionDTO;
    registro?: number;
    nombre?: string
    nif?: string
    nifRepresentante?: string
    paisIdentificacion?: string
    tipoIdentificacion?: number;
    numeroIdentificacion?: string
    varios?: number;
    numeroDocumento?: string
    fechaDocumento?: Date | string;
    actividad?: number;
    iva?: number;
    ivaIncluido?: number;
    regimenFiscal?: number;
    autodocumento?: number;
    rectificativa ?: number;
    textoRectificacion ?: string;
    fechaValor?: Date | string;
    referenciaTercero?: string
    referenciaInterna?: string
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    peso?: number;
    bultos?: number;
    volumen?: number;
    observaciones?: string
    fechaHoraImpresion?: Date | string;
    importeDescuento1?: number;
    importeDescuento2?: number;
    importeDescuento3?: number;
    importeDescuento4?: number;
    importeCancelado?: number;
    totalBruto?: number;
    totalBases?: number;
    totalIVA?: number;
    totalRecargo?: number;
    totalDocumento?: number;
    totalCargosFinal?: number;
    totalAbonosFinal?: number;
    totalRetenciones?: number;
    totalAPagar?: number;
    fechaPrevista?: Date | string;
    firmado?: number;
    referenciaExterna?: string
    estado?: number;
    noControlarExistencias?: boolean;
    checksum?: string;
    fechaRegistro ?: Date | string;
    referenciaOtraParte?: string
    fechaOperacion ?: Date | string;
    diferenciasEnCalculo?: number;
    fechaPrevistaEntrega?: Date | string;
    identificacionRespuesta?: string;
    fechaControlSincronizacion?: Date | string;
    ficheros?: ficherosGetDTO[];
}